// components/common/show-video-modal/ShowVideoModal.js
import React, { forwardRef, useImperativeHandle, useState } from "react";

const ShowVideoModal = forwardRef(({ videoPath }, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    }
  }));

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 max-w-md max-h-screen relative">
        {/* دکمه بستن ویدیو */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="بستن"
        >
          ✕
        </button>
        <video controls className="w-full h-auto">
          <source src={videoPath} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
});

export default ShowVideoModal;
